import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authMe, authRegister } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon
  const [chatUser, setChatUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ugp_chat_user") || "null"); } catch { return null; }
  });
  const [booting, setBooting] = useState(true);

  // Listen for taco chat auth bridge (Phase 1)
  useEffect(() => {
    const onMsg = (e) => {
      const d = e?.data;
      if (!d || d.type !== "taco-auth") return;
      setChatUser(d.user || null);
      try {
        if (d.user) localStorage.setItem("ugp_chat_user", JSON.stringify(d.user));
        else localStorage.removeItem("ugp_chat_user");
      } catch { /* ignore storage errors */ }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("ugp_token");
    if (!token) {
      setUser(null);
      setBooting(false);
      return;
    }
    try {
      const me = await authMe();
      setUser(me);
    } catch {
      localStorage.removeItem("ugp_token");
      setUser(null);
    } finally {
      setBooting(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (username, password) => {
    const { token, user } = await authLogin(username, password);
    localStorage.setItem("ugp_token", token);
    setUser(user);
    return user;
  };

  const register = async (username, password) => {
    const { token, user } = await authRegister(username, password);
    localStorage.setItem("ugp_token", token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("ugp_token");
    setUser(null);
  };

  const refreshMe = async () => {
    try {
      const me = await authMe();
      setUser(me);
    } catch {
      // ignore
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, chatUser, booting, login, register, logout, refreshMe }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
